import React from 'react'
import EmphasizedContent from './EmphasizedContent'
import Grid from './Grid'

export default function NudityNotification() {
    return (
        <EmphasizedContent>
            <h4>NUDE IMAGES ARE NOT ALLOWED! Any image that is disrespectful of race/religion will not be accepted.</h4>
            <p>Nude images are not accepted. It is participant responsibility to check conditions and section definitions. Nude images will be disqualified by organizers without prior notification and no entry fee refund.</p>
        </EmphasizedContent>
    )
}